// ⚡️ MARKETPLACE HEADER: YTproud Marketplace header component
// Extracted from ChatPanel.js for better organization and reusability

import React, { useEffect, useState } from 'react';
import { apiGet } from '../../../../utils/api';

const MarketplaceHeader = ({
  conversation,
  isDarkMode,
  dispatch,
  state,
  isAdmin = false
}) => {
  const [order, setOrder] = useState(null);

  useEffect(() => {
    let ignore = false;
    const load = async () => {
      if (!conversation?.order_id) return;
      try {
        // Try buyer list first, then seller list
        const tryEndpoints = isAdmin ? ['/api/orders/'] : ['/api/orders/my', '/api/orders/sales'];
        for (const ep of tryEndpoints) {
          const res = await apiGet(ep);
          if (!res.ok) continue;
          const list = await res.json();
          const found = Array.isArray(list) ? list.find(o => String(o.order_id) === String(conversation.order_id)) : null;
          if (found) { if (!ignore) setOrder(found); break; }
        }
      } catch {}
    };
    load();
    return () => { ignore = true; };
  }, [conversation?.order_id, isAdmin]);

  const orderDateText = order?.date ? new Date(order.date).toLocaleDateString() : (conversation?.order_date || '');
  return (
    <div className={`mb-3 w-full rounded-xl shadow-lg border transition-all duration-300 hover:shadow-xl px-4 py-3 ${
      isDarkMode ? 'bg-gradient-to-br from-[#0f0f0f] to-[#0f0f0f] border-gray-700/50' : 'bg-white border-gray-200'
    }`}>
      {/* Order Info Row */}
      <div className="w-full mb-3">
        <div className="flex items-center gap-3 px-4 py-3">
          {/* YTproud Logo */}
          <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-red-500 to-red-600 shadow-md">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="12" fill="#FF0000"/>
              <polygon points="10,8 16,12 10,16" fill="white"/>
            </svg>
          </div>
          
          {/* Branding Display */}
          <div className="flex-1">
            <div className={`font-bold text-lg ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>YTproud Marketplace</div>
            <div className={`text-xs ${
              isDarkMode ? 'text-gray-400' : 'text-gray-500'
            }`}>Order Details</div>
          </div>
          
          {/* Order Date & Collapse Button */}
          <div className="flex items-center gap-2">
            <div className={`text-xs px-2 py-1 rounded-lg ${
              isDarkMode ? 'text-gray-300 bg-[#1a1a1a]' : 'text-gray-700 bg-gray-100'
            }`}>{orderDateText}</div>
            <button
              onClick={() => dispatch({ type: 'TOGGLE_BOX_COLLAPSE', payload: 'orderDetails' })}
              className={`p-2 rounded-lg transition-all duration-200 ${
                isDarkMode 
                  ? 'hover:bg-gray-700 text-gray-300' 
                  : 'hover:bg-gray-100 text-gray-600'
              }`}
              aria-label="Toggle order details"
            >
              <svg className={`w-5 h-5 transition-transform duration-200 ${
                state.collapsedBoxes.orderDetails ? 'rotate-180' : ''
              }`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketplaceHeader;
